import { gql } from '@apollo/client';

/**
 * Minimal query to resolve a supplier entity's bot user ID.
 *
 * chat-service's legacy `chatCreate` handler requires `supplierId` to be a
 * supplier USER id (it calls getUserByIdHttp(supplierId) then resolves the
 * entity's botUserId internally). The distributor picker stores the ENTITY id,
 * so we resolve the botUserId here before calling the mutation.
 *
 * Named with the page prefix per monorepo convention to avoid codegen conflicts.
 */
export const ChatsPageGetSupplierBotUserQuery = gql`
  query ChatsPageGetSupplierBotUser($id: ID!) {
    supplier(id: $id) {
      id
      botUser {
        id
      }
    }
  }
`;
